import { motion } from 'framer-motion';
import { experiences } from '../constants';

const Experience = () => {
    return (
        <section id="experience" className="section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="flex items-center gap-4 mb-16"
                >
                    <span className="w-12 h-[1px] bg-primary-purple"></span>
                    <h2 className="text-4xl md:text-5xl font-bold">Experience</h2>
                </motion.div>

                <div className="relative pl-8 border-l border-white/10 ml-4 md:ml-10 space-y-16">
                    {experiences.map((exp, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: index * 0.2, duration: 0.6 }}
                            className="relative"
                        >
                            <div className="absolute -left-[41px] top-2 w-5 h-5 rounded-full bg-black border-2 border-primary-purple shadow-[0_0_10px_rgba(139,92,246,0.5)]"></div>

                            <div className="glass-card p-8 bg-white/[0.02] hover:bg-white/[0.05] border border-white/5">
                                <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-4 mb-6">
                                    <div>
                                        <h3 className="text-2xl font-bold text-white mb-1">
                                            {exp.role}
                                        </h3>
                                        <p className="text-lg text-primary-purple font-medium">
                                            {exp.company}
                                        </p>
                                    </div>
                                    <span className="text-sm text-gray-500 font-mono border border-white/10 px-3 py-1 rounded-full">
                                        {exp.duration}
                                    </span>
                                </div>
                                <p className="text-gray-400 leading-relaxed font-light">
                                    {exp.description}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
